"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Switcher;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = require("./icon.js");

require("../switcher.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var blockName = 'custom-switch';

function Switcher(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      onChange = _ref.onChange,
      name = _ref.name,
      ariaLabel = _ref.ariaLabel,
      unCheckedIcon = _ref.unCheckedIcon,
      checkedIcon = _ref.checkedIcon,
      id = _ref.id,
      onColor = _ref.onColor,
      disabled = _ref.disabled;
  var styledColor = onColor ? {
    background: onColor,
    border: "1px solid ".concat(onColor)
  } : '';
  var checkedIconWithColor = checkedIcon ? checkedIcon : (0, _icon.checkedIcon)(onColor);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(blockName, className)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "".concat(blockName, "__checkbox"),
    type: "checkbox",
    "aria-label": ariaLabel,
    name: name,
    checked: checked,
    onChange: onChange,
    id: id,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('animated', "".concat(blockName, "__shape")),
    style: checked ? styledColor : {}
  }, unCheckedIcon && !checked && /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(blockName, "__icon-text")
  }, unCheckedIcon), checked && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])("".concat(blockName, "__icon-text"), "".concat(blockName, "__icon-text--checked"))
  }, checkedIconWithColor)));
}

Switcher.defaultProps = {
  unCheckedIcon: _icon.uncheckedIcon,
  onColor: '#009688'
};
Switcher.propTypes = {
  id: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  ariaLabel: _propTypes["default"].string,
  className: _propTypes["default"].string,
  checked: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  checkedIcon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  unCheckedIcon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  disabled: _propTypes["default"].bool
};